export const themes = {
    light: {
        type: 'light',
        backgroundColor: 'bg-white',
        textColor: 'text-gray-800',
        linkColor: 'text-blue-500',
        navBg: 'bg-white',
        navText: 'text-gray-800',
        lightBg: 'bg-gray-300',
        borderColor: 'border-gray-800',
    },
    dark: {
        type: 'dark',
        backgroundColor: 'bg-gray-800',
        textColor: 'text-white',
        linkColor: 'text-blue-500',
        navBg: 'bg-gray-800',
        navText: 'text-white',
        lightBg: 'bg-gray-900',
        borderColor: 'border-gray-700',
    }
}